import { Group } from '../model/entities';
import { Page } from '../model/elements';
import apiAxios from './CustomAxios';

class GroupApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        branchId: number,
        searchText?: string,
    ): Promise<Page<Group>> => {
        const response = await apiAxios.get<Page<Group>>('/groups', {
            params: { page, size, sortField, sortOrder, branchId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;

        return response.data;
    };

    get = async (id: number): Promise<Group> => {
        const response = await apiAxios.get<Group>(`/groups/${id}`);
        return response.data;
    };
}

const groupApi: GroupApi = new GroupApi();
export default groupApi;
